import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import { FaInfoCircle } from "react-icons/fa";
import styled from "styled-components";
import InviteUserDrawer from "./InviteUserDrawer";
import UserExpenseCard from "./UserExpenseCard";
import ExpenseRolesModal from "./ExpenseRolesModal";
import { ExpenseService } from "../../../_service/ExpenseService";
import { useAppSelector } from "../../../_app";
import { Utils } from "../../../utils";
import { LoaderContainer } from "../../../CommonStyles";
import { Loader } from "../../../components";

const users = [
  {
    id: 1,
    name: "James Wilson",
    roles: ["Expenses (Submitter)"],
    status: "Invited",
    access: "invited",
  },
  {
    id: 2,
    name: "Ryan doe",
    roles: ["Expense (Admin)", "Advisor", "Manage User"],
    access: "granted",
  },
  {
    id: 5,
    name: "Mong Chong Chai",
    roles: ["Expense (Admin)", "Advisor", "Manage User"],
    access: "granted",
  },
  {
    id: 7,
    name: "Sim Chai",
    roles: ["Expense (Admin)", "Advisor", "Manage User"],
    access: "granted",
  },
  {
    id: 3,
    name: "Amberlyn Chong",
    roles: ["Invoice only (Sales)", "Invoice only (Draft)"],
    access: "none",
  },
  {
    id: 4,
    name: "OngMo Chong",
    roles: ["Invoice only (Sales)", "Invoice only (Draft)"],
    access: "none",
  },
];

const Container = styled.div`
  /* No additional styles needed */
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: #283a44;
  text-transform: capitalize;
  margin-right: auto;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  margin-left: auto;
  cursor: pointer;
  padding: 10px;
`;

const ExpenseRolesText = styled.p`
  color: #28a745;
  margin-right: 1rem;
  border-bottom: 1px solid #28a745;
  padding-bottom: 2px;
`;

const StyledInviteButton = styled.p`
  font-size: 16px;
  border: 1px solid #28a745;
  background-color: #28a745;
  color: #ffffff;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 0;

  &:hover {
    background-color: #218838;
    border-color: #218838;
    transform: scale(1.01);
  }
`;

const Divider = styled.hr`
  border: 1px solid #e0e0e0;
  margin: 0.5rem 0;
`;

const H3 = styled.div`
  font-size: 15px;
  color: "#283A44";
  padding-bottom: 0.5rem;
  font-weight: 600;
`;

const ManageUserExpense = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showRolesModal, setShowRolesModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showSelectUserDropdown, setShowSelectUserDropdown] = useState(false);

  const [selectedUser, setSelectedUser] = useState<any>(null);

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);

  const [expenseEmployeeData, setExpenseEmployeeData] = useState({
    pending: [],
    access: [],
    no_access: [],
  });

  const [emailTemplate, setEmailTemplate] = useState({
    expenseOnly: '',
    expenseOnlySubject: '',
    expenseAndSelfService: '',
    expenseAndSelfServiceSubject: '',
  });

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
    setSelectedUser(null);
    setShowSelectUserDropdown(true);
  };

  const handleAddEditUser = (user: any) => {
    console.log("Selected user:", user);
    setSelectedUser(user);
    setDrawerOpen(true);
    setShowSelectUserDropdown(false);
  };

  const getExpenseEmployees = async () => {
    setIsLoading(() => true);
    try {
      const res = await ExpenseService._getExpenseEmployeeList(companyId);
      const expenseTemplateRes = await ExpenseService._getExpenseOnlyTemplate();
      const expenseAndSelfServiceTemplateRes = await ExpenseService._getExpenseAndSelfServiceTemplate();
      if (res.status === 200) {
        setExpenseEmployeeData(() => res.data.data);

        setEmailTemplate(() => ({
          expenseOnly: expenseTemplateRes?.data?.data?.[0]?.email_body || "",
          expenseOnlySubject: expenseTemplateRes?.data?.data?.[0]?.email_subject || "",
          expenseAndSelfService: expenseAndSelfServiceTemplateRes?.data?.data?.[0]?.email_body || "",
          expenseAndSelfServiceSubject: expenseAndSelfServiceTemplateRes?.data?.data?.[0]?.email_subject || ""
        }));
        
        setIsLoading(() => false);
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
      setIsLoading(() => false);
    }
  };

  useEffect(() => {
    getExpenseEmployees();
  }, []);

  console.log("expenseEmp", expenseEmployeeData);
  console.log("emailTemplate", emailTemplate);

  return (
    <Container>
      {isLoading && (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      )}
      <HeaderContainer>
        {/* <Title>Manage User Expenses</Title> */}

        <HeaderActions>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: 'pointer' }} onClick={() => setShowRolesModal(true)} >
            <FaInfoCircle color="#28A745" size={20} />
            <ExpenseRolesText>
              Expense Roles
            </ExpenseRolesText>
          </div>

          <StyledInviteButton onClick={handleDrawerToggle}>
            Invite User
          </StyledInviteButton>
        </HeaderActions>
      </HeaderContainer>

      {/* <Divider /> */}

      <ExpenseRolesModal
        isOpen={showRolesModal}
        onClose={() => setShowRolesModal(false)}
      />
      <div style={{ color: "#283A44" }}>
        <div style={{ maxWidth: 900, margin: "auto", padding: 10 }}>
          <H3>Invited to Expenses</H3>
          {expenseEmployeeData?.pending?.length > 0 ? (
            expenseEmployeeData?.pending?.map((user: any, index) => (
              <UserExpenseCard
                key={user.id}
                id={user.id}
                user={user?.user}
                onAdd={handleAddEditUser}
                onEdit={handleAddEditUser}
                access="invited"
                jobTitle={user?.job_title}
                roles={user?.expense_settings?.roles}
                refetch={getExpenseEmployees}
                expenseId={user?.expense_settings?.id}
                bgColor={
                  Utils.LIGHT_COLOR_CODES[
                    index % Utils.LIGHT_COLOR_CODES.length
                  ]
                }
              />
            ))
          ) : (
            <p
              style={{
                color: "#6c757d",
                fontStyle: "italic",
                margin: "10px 0",
              }}
            >
              No users currently invited to Expenses.
            </p>
          )}
        </div>

        <div style={{ maxWidth: 900, margin: "auto", padding: 10 }}>
          <H3>Access to Expenses</H3>
          {expenseEmployeeData?.access?.length > 0 ? (
            expenseEmployeeData?.access?.map((user: any, index) => (
              <UserExpenseCard
                key={user.id}
                id={user.id}
                user={user?.user}
                onAdd={handleAddEditUser}
                onEdit={handleAddEditUser}
                access="granted"
                jobTitle={user?.job_title}
                roles={user?.expense_settings?.roles}
                refetch={getExpenseEmployees}
                expenseId={user?.expense_settings?.id}
                bgColor={
                  Utils.LIGHT_COLOR_CODES[
                    index % Utils.LIGHT_COLOR_CODES.length
                  ]
                }
              />
            ))
          ) : (
            <p
              style={{
                color: "#6c757d",
                fontStyle: "italic",
                margin: "10px 0",
              }}
            >
              No user has accepted the invite.
            </p>
          )}
        </div>

        <div style={{ maxWidth: 900, margin: "auto", padding: 10 }}>
          <H3>No Access to Expenses</H3>
          {expenseEmployeeData?.no_access?.length > 0 ? (
            expenseEmployeeData?.no_access?.map((user: any, index) => (
              <UserExpenseCard
                key={user.id}
                id={user.id}
                user={user?.user}
                onAdd={handleAddEditUser}
                onEdit={handleAddEditUser}
                access="none"
                jobTitle={user?.job_title}
                refetch={getExpenseEmployees}
                expenseId={user?.expense_settings?.id}
                roles={user?.expense_settings?.roles}
                bgColor={
                  Utils.LIGHT_COLOR_CODES[
                    index % Utils.LIGHT_COLOR_CODES.length
                  ]
                }
              />
            ))
          ) : (
            <p
              style={{
                color: "#6c757d",
                fontStyle: "italic",
                margin: "10px 0",
              }}
            >
              No users currently without access to Expenses.
            </p>
          )}
        </div>
      </div>

      <InviteUserDrawer
        open={drawerOpen}
        onClose={handleDrawerToggle}
        user={selectedUser}
        refetch={getExpenseEmployees}
        noAccessUsers={expenseEmployeeData?.no_access || []}
        showSelectUserDropdown={showSelectUserDropdown}
        emailTemplate={emailTemplate}
      />
    </Container>
  );
};

export default ManageUserExpense;
